// Canonical logbook entries from a 100% Metroid Prime: Origins slot save.
// Field keys are `Logbook <Section>: <Entry>` (value 1 = scanned).

export const LOGBOOK_CATALOG = {
  pirateData: {
    label: "Pirate Data",
    prefix: "Logbook Pirate Data",
    entries: [
      "Fall of Zebes",
      "The Hunter",
      "Contact",
      "Artifact Site",
      "Phazon Analysis",
      "Phazon Program",
      "Metroid Studies",
      "Parasite Larva",
      "Mining Status",
      "Glacial Wastes",
      "Security Breaches",
      "Proejct Meta Ridley",
      "Phazon Infusion",
      "The Elite Pirates",
      "The Metroid Prime",
      "Hunter Weapons",
      "The Omega Pirate",
      "Special Forces",
      "Prime Breach",
      "Prime Mutations",
      "Metroid Morphology",
      "Chozo Studies",
      "The Chozo Artifacts",
      "Metroid Forces",
      "The Chozo Ghosts",
    ],
  },
  chozoLore: {
    label: "Chozo Lore",
    prefix: "Logbook Chozo Lore",
    entries: [
      "Beginnings",
      "Infestation",
      "Binding",
      "Cradle",
      "Cipher",
      "Worm",
      "Fountain",
      "Exodus",
      "Hatchling's Spell",
      "Hatchling",
      "Meteor Strike",
      "Contain",
      "The Turned",
      "Hope",
      "Statuary",
      "Newborn",
    ],
  },
  creatures: {
    label: "Creatures",
    prefix: "Logbook Creatures",
    entries: [
      "Parasite",
      "Auto Turret",
      "Zoomer",
      "Geemer",
      "Sap Sac",
      "Bloodflower",
      "Seedling",
      "Scarab",
      "Beetle",
      "Plated Beetle",
      "War Wasp",
      "Ram War Wasp",
      "Barbed War Wasp",
      "Hive",
      "Eyon",
      "Plazmite",
      "Shriekbat",
      "Tangle Weed",
      "Venom Weed",
      "Blastcap",
      "Reaper Vine",
      "Stone Toad",
      "Plated Parasite",
      "Oculus",
      "Plated Puffer",
      "Hive Mecha",
      "Incinerator Drone",
      "Chozo Ghost",
      "Golden Guard",
      "Grizby",
      "Burrower",
      "Puffer",
      "Triclops",
      "Magmoor",
      "Puddle Spore",
      "Crystallite",
      "Ice Parasite",
      "Ice Shriekbat",
      "Pulse Bombu",
      "Scatter Bombu",
      "Ice Burrower",
      "Ice Beetle",
      "Flickerbat",
      "Jelzap",
      "Baby Sheegoth",
      "Sheegoth",
      "Sentry Drone",
      "Space Pirate",
      "Shadow Pirate",
      "Flying Pirate",
      "Aqua Sac",
      "Tallon Crab",
      "Aqua Reaper",
      "Aqua Drone",
      "Aqua Pirate",
      "Mega Turret",
      "Glider",
      "Power Trooper",
      "Wave Trooper",
      "Ice Trooper",
      "Plasma Trooper",
      "Elite Pirate",
      "Phazon Elite",
      "Metroid",
      "Hunter Metroid",
      "Fission Metroid",
      "Phazon Hunter",
      "Plated Hunter",
      "Hunter Larva",
      "Alpha Hunter",
      "Gamma Hunter",
      "Zeta Hunter",
      "Lumigek",
      "Phazon Blastcap",
      "Phazon Burrower",
      "Parasite Queen",
      "Flaahgra",
      "Thardus",
      "Omega Pirate",
      "Meta Ridley",
      "Metroid Prime Exo",
      "Metroid Prime Core",
    ],
  },
}
